import {
  ApolloClient,
  ApolloLink,
  from,
  InMemoryCache,
  split,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { createUploadLink } from 'apollo-upload-client';
import { Subject } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { map, tap } from 'rxjs/operators';
import settings from './settings';
import queryString from 'query-string';

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      );
      if (message.includes('Missing authorization header')) {
        const params = queryString.parse(window.location.search);
        const search = `?${queryString.stringify({
          p: window.location.pathname,
          s: JSON.stringify(params),
        })}`;
        window.location.href = `/sign-in${search}`;
      }
    });
  }
  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
});

const httpLink = createUploadLink({
  uri: settings.apiUrl,
  fetch: async (url, options) => {
    if (options.onProgress) {
      const progressSubscriber = new Subject();
      const request$ = ajax({
        url,
        ...options,
        progressSubscriber,
      });
      progressSubscriber.subscribe((event) => options.onProgress(event));
      return request$
        .pipe(
          tap((response) => console.log(response)),
          map((response) => {
            return {
              ...response,
              text: async () => JSON.stringify(response.response),
            };
          }),
        )
        .toPromise();
    }
    return fetch(url, options);
  },
});

function getConnectionParams() {
  const token = localStorage.getItem('authToken');
  return {
    authToken: `Bearer ${token}`,
  };
}

const wsLink = new WebSocketLink({
  uri: settings.apiWsUrl,
  options: {
    reconnect: true,
    connectionParams: getConnectionParams,
  },
});
console.log('wsLink', wsLink);

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    operation.setContext({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  return forward(operation);
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  from([authMiddleware, errorLink, httpLink]),
);

class ApolloClientWS extends ApolloClient {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
  }

  close() {
    return wsLink.subscriptionClient.close();
  }
}

const client = new ApolloClientWS({
  cache: new InMemoryCache(),
  link: splitLink,
});

export default client;
